module.exports = __webpack_public_path__ + "images/516b43aadc5006ee94d6f5944aebda7e.svg";